export default __webpack_public_path__ + "64f89ad1637773070c31b9f869582332.svg";